import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-money\">\n  <path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z\" fill=\"currentColor\" p-id=\"10427\" />\n  <path d=\"M559.9 421.5c-59.9-8.1-86.4-19.5-86.4-33.3 0-13.3 24.6-22.7 58.8-22.7 27.3 0 56.2 7 77.9 18.9 5.9 3.2 13.2 1.4 16.8-4.1l17.8-27.2c3.6-5.5 2.2-12.9-3.3-16.5-22.1-14.6-49.6-22.9-77.4-25.7v-37.1c0-6.7-5.4-12.1-12.1-12.1h-24.4c-6.7 0-12.1 5.4-12.1 12.1v37.2c-36.6 3.4-64.1 19.3-64.1 50.7 0 32.2 29.3 49.5 99.5 61.5 54.8 9.3 79.3 21.2 79.3 34.8 0 14.5-25.7 24.6-63.5 24.6-33.5 0-67.6-10.8-93.4-29.7-5.4-4-13.2-2.6-16.8 3.1l-17.8 28.1c-3.6 5.6-2.1 13 3.5 16.6 28.1 18.8 63.7 29.8 100.9 32.4v36.8c0 6.7 5.4 12.1 12.1 12.1h24.4c6.7 0 12.1-5.4 12.1-12.1v-36.8c37.2-2.8 65.1-18.4 65.1-50.8 0-31.6-29.9-49.1-101.9-61.5z\" fill=\"currentColor\" p-id=\"10428\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/money.svg
// module id = ig9B
// module chunks = 117